import api from "./api";

// Registro de auditoría de seguridad (doc 0431, M-09). Solo lectura.
export const listSecurityEvents = (params) => api.get("/security-audit", { params });
